// extracted by mini-css-extract-plugin
export default {"close":"ModalCloseButton_close__bANBy"};